import React, { useState, useEffect } from 'react';
import axios from 'axios';
import UserStatus from './UserStatus';
import API from '../api';


const Forgot_Password = () => {
const [email, setEmail] = useState('');
const [message, setMessage] = useState('');
const [cooldown, setCooldown] = useState(0);
const [timerId, setTimerId] = useState(null);

useEffect(() => {
  document.title = "Forgot Password | TradeBarta.com";
}, []);

    useEffect(() => {
    setCooldown(0);
  }, []);


  useEffect(() => {
    return () => {
      if (timerId) clearInterval(timerId);
    };
  }, [timerId]);

  const startCooldown = () => {
    setCooldown(120); // 2 minutes

    const interval = setInterval(() => {
      setCooldown(prev => {
        if (prev <= 1) {
          clearInterval(interval);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    setTimerId(interval);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

      if (cooldown > 0) {
      setMessage(`Please wait ${cooldown} seconds before requesting again.`);
      return;
    }

    try {
      //const res = await API.post(`${process.env.REACT_APP_API_URL}/api/forgot-password`, { email });
      const res = await API.post(`/api/forgot-password`, { email });
      setMessage(res.data.message);
      startCooldown();
    } catch (err) {
      setMessage(err.response?.data?.message || 'Error occurred');
    }
  };

  return (
    <div className="page-container">
      <div className="content-wrap">
      <section className="navbar-area navbar-one">
    <div className="container">
      <div className="row">
        <div className="col-lg-12">
          <nav className="navbar navbar-expand-lg">
            <a className="navbar-brand" href="/">
              <img width = "200" height = "70" src={require("../images/logo.png")} alt="Logo" />
            </a>

            <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarOne"
              aria-controls="navbarOne" aria-expanded="false" aria-label="Toggle navigation">
              <span className="toggler-icon"></span>
              <span className="toggler-icon"></span>
              <span className="toggler-icon"></span>
            </button>

            <div className="collapse navbar-collapse sub-menu-bar" id="navbarOne">
              <ul className="navbar-nav m-auto">
                <li className="nav-item">
                  <a className="active page-scroll" href="/">Home</a>
                </li>
                <li className="nav-item">
                  <a className="page-scroll" href="/pricing">Pricing</a>
                </li>
                
                <li className="nav-item">
                  <a className="page-scroll" href="/referral">Refer and Win</a>
                </li>
                <li className="nav-item">
                  <a className="page-scroll" href="/faq">FAQ</a>
                </li>
                <li className="nav-item">
                  <a className="page-scroll" href="/contact">Contact Us</a>
                </li>
                
              </ul>
            </div>
        
          <div className="navbar-btn d-none d-sm-inline-block">
                  <UserStatus />      
          </div>
      </nav>
        </div>
      </div>
    </div>
  </section>

 <section id="hero-area" className="header-area header-ten">
        <div className="header-inner">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-4 co-12">
                <div className="home-slider">
                  <div className="form-container">
      <h1>Forgot Password</h1>
      <form onSubmit={handleSubmit}>
        <input
          type="email"
          placeholder="Enter email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <button type='submit' disabled={cooldown > 0}>
                          {cooldown > 0 ? `Wait ${cooldown}s to request again` : 'Send Reset Link'}
                        </button>        
      </form>
          {message && (
                <p style={{ color: message.includes('success') ? 'green' : 'red' }}>
                  {message}
                </p>
              )}          
          </div>
            </div>
          </div>
         </div>
      </div>
    </div>
  </section>
</div>
<section className="footer-area footer-five">
  <div className="container">
    <div className="footer-top-content">
      
      {/* Links Section */}
      <div className="footer-links">
        <ul>
          <li>
            <a href="/terms" target="_blank" rel="noopener noreferrer">
              Terms & Conditions
            </a>
          </li>
          <li>
            <a href="/privacy" target="_blank" rel="noopener noreferrer">
              Privacy Policy
            </a>
          </li>
        </ul>
      </div>

      {/* Contact Section */}
      <div className="footer-contact">
        <h4>Contact Us:</h4>
        <a href="mailto:support@tradebarta.com">support@tradebarta.com</a>
      </div>

    </div>
  </div>

  {/* Bottom copyright section */}
  <div className="footer-copyright">
    <div className="container">
      <p className="text-center">Copyright © 2025. All Rights Reserved</p>
    </div>
  </div>
</section>

</div>

  );
};

export default Forgot_Password;
